import {LitElement, html, css} from 'lit';
import {connect} from 'pwa-helpers';
import {customElement} from 'lit/decorators/custom-element.js';
import {when} from 'lit/directives/when.js';
import {msg} from '@lit/localize';
import store from '../../../store';
import {
	selectLdt1,
	selectDimensionHeight,
	selectDimensionWidth,
	selectDimensionDepth,
	selectMountingInstruction,
	selectSpcConfiguration
} from '../../../selectors';
import {conditional} from '../../../util/conditional';


@customElement('light-profile-image')
export class LightProfileImage extends connect(store)(LitElement) {

	static styles = [
		css`
		.page-container {
			display: flex;
			width: 100vw;
			margin-top: 80px;
		}

		.diagrams {
			width: 50vw;
		}

		.description {
			font: var(	--font-specsheet-print-light);
			width: 46vw;
		}

		.downloads {
			margin-top: 50px;
			font: var(--font-specsheet-print-bold);
		}

		a {
			color: #000;
		}

		p {
			font: var(--font-specsheet-print-light);
		}

		p span {
			font: var(--font-specsheet-print-bold);
		}
		.image {
			margin-bottom: 60px;
		}

		.sketch  {
			height: 230px;
		}

		.title {
			color: var(--color-black);
			font-size: var(--font-size-sections);
			font-weight: bold;
		}
		`
	];

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.lang = this.state.status.lang;
		this.spcConfiguration = selectSpcConfiguration(state);
		this.conditionalVariantValues = state.productData.conditionalVariantValues;
		this.translations = state.productData.translations;
		this.profile = state.lightProfile.data.profile;
		this.lightProfile = state.lightProfile.data;
		this.productData = state.productData.productData;
		this.lang = state.status.lang;
	}
	c(id) {
		return conditional(this.spcConfiguration, this.conditionalVariantValues, id);
	}
	render() {
		const s = this.state;
		return html`
			<div class="diagrams">
				<div class="image">
					${when( this.c('REDTAB.RETURN_LE_PolarDiagramP2') && this.c('REDTAB.RETURN_LE_PolarDiagramP2') !=='', () => html`
					<img alt="polar diagram" src="${this.c('REDTAB.RETURN_LE_PolarDiagramP2')}" />
					`)}
				</div>
				<!--<trans-label class="title" slot="title" key="TE_Dimensions" context="D"></trans-label>!-->
				<div slot="content">
					${when( this.c('REDTAB.RETURN_LU_Sketch') && this.c('REDTAB.RETURN_LU_Sketch') !=='', () => html`
					<img class="sketch" alt="sketch" src="${this.c('REDTAB.RETURN_LU_Sketch')}" />
					`)}
					<p>L: ${selectDimensionDepth(s)} mmm, B: ${selectDimensionWidth(s)} mm, H: ${selectDimensionHeight(s)} mm</p>
				</div>
			</div>
`;
}
}
